import { render, staticRenderFns } from "./plan-card.vue?vue&type=template&id=562829c6&scoped=true&"
import script from "./plan-card.vue?vue&type=script&lang=js&"
export * from "./plan-card.vue?vue&type=script&lang=js&"
import style0 from "./plan-card.vue?vue&type=style&index=0&id=562829c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562829c6",
  null
  
)

export default component.exports